import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { customRegisterGuard } from '@lfg-guards/custom-register/custom-register.guard';

const routes: Routes = [
  { path: 'sign-up', loadChildren: () => import('./sign-up/sign-up.module').then(m => m.SignUpModule) },
  {
    path: 'custom-register',
    canActivate: [customRegisterGuard],
    loadChildren: () => import('./custom-register/custom-register.module').then(m => m.CustomRegisterModule)
  },
  {
    path: 'complete-subscription',
    loadChildren: () => import('./custom-register/custom-register.module').then(m => m.CustomRegisterModule)
  },
  { path: 'password-recovery', loadChildren: () => import('./password-recovery/password-recovery.module').then(m => m.PasswordRecoveryModule) }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthenticationRoutingModule { }
